import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../components/Layout'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: 'home',
          component: () => import('../pages/Home.vue'),
          name: 'home',
          meta: { title: '上海趋致信息技术-首页' }
        },
        {
          path: 'reports',
          component: () => import('../pages/Reports.vue'),
          name: 'reports',
          meta: { title: '上海趋致信息技术-关于' }
        },
        {
          path: 'down',
          component: () => import('../pages/Down.vue'),
          name: 'down',
          meta: { title: '上海趋致信息技术-下载' }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '上海趋致信息技术'
  next()
})

export default router